import React, {Component} from 'react'
import styles from './SlideShow.css'

export default class SlideShow extends Component {
  state = {
    current: 0,
    alternatingBool: false,
  }

  nextSlide = () => {
    this.setState({
      current: (this.state.current + 1) % this.props.slideShow.length,
      alternatingBool: !this.state.alternatingBool,
    })
  }

  componentDidMount () {
    this.interval = setInterval(this.nextSlide, 10000)
  }

  componentWillUnmount () {
    clearInterval(this.interval)
  }

  render () {
    const prev = this.props.slideShow[this.state.current]
    const curr = this.props.slideShow[(this.state.current + 1) % this.props.slideShow.length]
    const next = this.props.slideShow[(this.state.current + 2) % this.props.slideShow.length]
    return (
      <div className={styles.cont}>
        <Item image={prev} key={prev} fromRight={this.state.alternatingBool}/>
        <Item image={curr} key={curr} animate fromRight={!this.state.alternatingBool}/>
        <Item image={next} key={next} loading />
      </div>
    )
  }
}

class Item extends Component {
  render () {
    return (
      <div
        className={[
          styles.item,
          this.props.fromRight ? styles.fromRight : '',
          this.props.animate ? styles.animate : '',
          this.props.loading ? styles.loading : '',
        ].join(' ')}
        style={{
          backgroundImage: 'url(' + this.props.image + ')',
        }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/Rist/modules/SlideShow/index.js